export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_DELIVERY = 'ADD_DELIVERY';
export const SUB_DELIVERY = 'SUB_DELIVERY';
export const RESETSTATE = 'RESETSTATE';
